export const ADMIN = 1

export const PROPRIETARIO = 2

export const CORRETOR = 3